import React from "react";
import { Button, Modal } from "antd";

import TextInfo from "../TextInfo/TextInfo";

import "../styles.css";
import {
  AuthorizationList,
  CanAccess,
} from "../../template/authorization/Authorization";

const RejectDialog = ({
  visible,
  handleCancel,
  handleSave,
  hasCancel,
  isDangerButton,
  actionButtonText,
  title,
  handleChange,
  errors,
  reasonValue,
  isStyleBlock = false,
}) => {
  return (
    <Modal
      className="modal-form"
      title={title}
      visible={visible}
      onCancel={handleCancel}
      width={"30%"}
      centered
      footer={[
        hasCancel && (
          <Button
            key="back"
            onClick={handleCancel}
            className="btn-modal btn-default"
          >
            Kembali
          </Button>
        ),
        <CanAccess
          role={AuthorizationList.update_waiting_disburse}
          yes={
            <Button
              key="submit"
              type="primary"
              danger={isDangerButton}
              onClick={handleSave}
              className="btn-modal-danger"
            >
              {actionButtonText}
            </Button>
          }
        />,
      ]}
    >
      <div className={isStyleBlock ? "" : "modal-form-content"}>
        <TextInfo
          title="Alasan"
          value={reasonValue}
          isTextArea
          type={"textarea"}
          id={"reason"}
          handleChange={handleChange}
          error={errors?.reason}
          placeholder={"Masukkan Alasan"}
          isForm
          isStyleBlock={isStyleBlock}
        />
      </div>
    </Modal>
  );
};

export default RejectDialog;
